function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Text, TSpan, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 43.478,
  height: 43.458,
  rx: 13
}), /*#__PURE__*/React.createElement(Text, {
  fill: "#FFF",
  fontFamily: "HalisR-Bold, Halis R",
  fontSize: 16,
  fontWeight: "bold",
  letterSpacing: -0.333
}, /*#__PURE__*/React.createElement(TSpan, {
  x: 17.879,
  y: 27
}, "3")), /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  opacity: 0.2
}, /*#__PURE__*/React.createElement(Path, {
  d: "M8 27.335V12.9C8 10.747 9.88 9 12.199 9h14.468m.184 0h4.777c2.318 0 4.2 1.747 4.2 3.9v4.435m-.001.171v13.435c0 2.153-1.881 3.899-4.199 3.899H16.082"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M16.975 34.84h-4.776C9.879 34.84 8 33.094 8 30.94v-4.434"
})));

function SvgIconThirdPlan(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _ref);
}

export default SvgIconThirdPlan;